import React from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';

const Faculty = () => {
  const { t } = useTranslation();
  return <PageTemplate title={t('faculty.title')} />;
};

export default Faculty; 